export default "__VITE_ASSET__549367d4__"